import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[bookshelfTemplateSortAction]',
})
export class BookshelfTemplateSortActionDirective {
  constructor(public template: TemplateRef<any>) {
  }
}
